module.exports = __webpack_public_path__ + "static/media/ja.f8dc0f04.svg";